import { useState } from "react";
import {
    approveContribution,
    rejectContribution,
    type Contribution,
} from "../../../api/adminContributions";

interface Props {
    contribution: Contribution;
    onAction: () => void;
}

export default function ContributionCard({ contribution, onAction }: Props) {
    const [loading, setLoading] = useState(false);
    const [score, setScore] = useState<number>(10);
    const [rejectNotes, setRejectNotes] = useState("");

    const handleApprove = async () => {
        setLoading(true);
        try {
            await approveContribution(contribution._id, score);
            onAction();
        } catch (err) {
            console.error("Failed to approve", err);
        } finally {
            setLoading(false);
        }
    };

    const handleReject = async () => {
        setLoading(true);
        try {
            await rejectContribution(contribution._id, rejectNotes);
            onAction();
        } catch (err) {
            console.error("Failed to reject", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ctrb-card" style={{ background: "var(--card-bg)", padding: 20, borderRadius: 12, border: "1px solid var(--card-border)", marginBottom: 16, boxShadow: "var(--db-shadow)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 8 }}>
                <h3 style={{ fontSize: 16, fontWeight: 600, color: "var(--color-text)" }}>{contribution.forum_name}</h3>
                <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 999, background: "rgba(245, 158, 11, 0.1)", color: "#fbbf24", border: "1px solid rgba(245, 158, 11, 0.3)", textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.05em" }}>
                    {contribution.status}
                </span>
            </div>

            <div style={{ fontSize: 13, color: "var(--color-text-muted)", marginBottom: 12 }}>
                <p style={{ margin: "4px 0" }}><strong>URL:</strong>{" "}
                    <a href={contribution.primary_url} style={{ color: "#818cf8", textDecoration: "none" }}>
                        {contribution.primary_url}
                    </a>
                </p>
                {contribution.mirror_urls && contribution.mirror_urls.length > 0 && (
                    <p style={{ margin: "4px 0" }}><strong>Mirrors:</strong> {contribution.mirror_urls.join(", ")}</p>
                )}
                {contribution.notes && (
                    <p style={{ margin: "4px 0" }}><strong>Notes:</strong> {contribution.notes}</p>
                )}
                <p style={{ fontSize: 11, color: "var(--color-text-subtle)", marginTop: 8 }}>
                    Submitted by: {contribution.submitted_by} &bull;{" "}
                    {new Date(contribution.created_at).toLocaleDateString()}
                </p>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 10, borderTop: "1px solid var(--color-border)", paddingTop: 16 }}>
                <div style={{ display: "flex", gap: 8 }}>
                    <input
                        type="number"
                        value={score}
                        onChange={(e) => setScore(Number(e.target.value))}
                        style={{ border: "1px solid var(--color-border)", borderRadius: 8, padding: "6px 10px", width: 72, fontSize: 13, background: "var(--color-bg)", color: "var(--color-text)", outline: "none" }}
                        placeholder="Score"
                        min={0}
                        max={100}
                        disabled={loading}
                    />
                    <button
                        onClick={handleApprove}
                        disabled={loading}
                        style={{ flex: 1, background: "linear-gradient(135deg, #10b981 0%, #059669 100%)", color: "#fff", border: "none", borderRadius: 8, padding: "6px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: loading ? 0.5 : 1, boxShadow: "0 4px 14px rgba(16, 185, 129, 0.2)" }}
                    >
                        Approve
                    </button>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                    <input
                        type="text"
                        value={rejectNotes}
                        onChange={(e) => setRejectNotes(e.target.value)}
                        style={{ flex: 1, border: "1px solid var(--color-border)", borderRadius: 8, padding: "6px 12px", fontSize: 13, background: "var(--color-bg)", color: "var(--color-text)", outline: "none" }}
                        placeholder="Rejection reason..."
                        disabled={loading}
                    />
                    <button
                        onClick={handleReject}
                        disabled={loading}
                        style={{ background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)", color: "#fff", border: "none", borderRadius: 8, padding: "6px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: loading ? 0.5 : 1, boxShadow: "0 4px 14px rgba(239, 68, 68, 0.2)" }}
                    >
                        Reject
                    </button>
                </div>
            </div>
        </div>
    );
}
